import * as React from "react"
import { useRef, useEffect } from "react"

// Components
import { Section, Container } from "../StyledComponents/layoutComponentStyles"
import { postSerializer } from "../../utils/blockContentSerializer"
import PortableText from "@sanity/block-content-to-react"

// Styles
import "./_break-banner.scss"

// Animations
import { createTriggerRevealTitle, createTriggerSlideText } from "../../animations/globalAnims"

interface BreakBannerProps {
  module: any
}

/*









*/

const BreakBanner: React.FunctionComponent<BreakBannerProps> = ({ module }) => {
  // Refs
  const titleRef = useRef<HTMLHeadingElement>(null)
  const parRef = useRef<HTMLDivElement>(null)

  // Effects
  useEffect(() => {
    const parChildren =
      parRef.current?.children[0].nodeName !== "DIV" ? parRef.current?.children : parRef.current?.children[0]?.children
    const parChildrenArray: Array<Element> = Array.from(parChildren ? parChildren : [])

    createTriggerRevealTitle(titleRef.current)
    createTriggerSlideText(parChildrenArray, 0.6)
  }, [])

  return (
    <Section>
      <Container fourteenClm>
        <div className='o-break-banner'>
          <div className='o-break-banner__sml-clm'>
            <h4 ref={titleRef}>{module.bannerTitle}</h4>
          </div>
          <div ref={parRef} className='o-break-banner__par'>
            <PortableText blocks={module._rawBannerContent} serializers={postSerializer} />
          </div>
        </div>
      </Container>
    </Section>
  )
}

export default BreakBanner
